var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React, { useMemo, useCallback, useState, useEffect, useRef } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
const prefixCls = createPrefixCls('radio-group');
export const RadioGroup = (_a) => {
    var { children, className, disabled, layout = 'between', checked, defaultChecked, onChange, formValue, setFormValue } = _a, restProps = __rest(_a, ["children", "className", "disabled", "layout", "checked", "defaultChecked", "onChange", "formValue", "setFormValue"]);
    const defaultCheckedRef = useRef(defaultChecked);
    const getPropsChecked = useMemo(() => {
        if (formValue !== undefined) {
            return formValue;
        }
        else if (checked !== undefined) {
            return checked;
        }
        else {
            return undefined;
        }
    }, [checked, formValue]);
    const [val, setVal] = useState(getPropsChecked === undefined ? defaultCheckedRef.current || false : getPropsChecked);
    useEffect(() => {
        if (setFormValue) {
            if (getPropsChecked !== undefined) {
                setFormValue(checked);
            }
            else if (defaultCheckedRef.current !== undefined) {
                setFormValue(defaultCheckedRef.current);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useUpdate(() => {
        setVal(getPropsChecked);
        if (setFormValue && getPropsChecked !== undefined) {
            setFormValue(getPropsChecked);
        }
    }, [getPropsChecked]);
    const handleChildChange = useCallback((val) => {
        if (!disabled) {
            setVal(val);
            onChange && onChange(val);
            setFormValue && setFormValue(val);
        }
    }, [disabled, onChange, setFormValue]);
    const radioGroupCls = useMemo(() => {
        return classnames([prefixCls(), prefixCls(layout), className]);
    }, [className, layout]);
    return (React.createElement("div", Object.assign({ className: radioGroupCls }, restProps), React.Children.map(children, (child) => {
        return React.cloneElement(child, Object.assign({ groupValue: checked === undefined ? val : checked, onChange: handleChildChange }, (disabled ? { disabled } : {})));
    })));
};
export default RadioGroup;
